import { render, staticRenderFns } from "./NetPremiumUsdProperty.vue?vue&type=template&id=b52f0886&scoped=true&"
import script from "./NetPremiumUsdProperty.vue?vue&type=script&lang=js&"
export * from "./NetPremiumUsdProperty.vue?vue&type=script&lang=js&"
import style0 from "./NetPremiumUsdProperty.vue?vue&type=style&index=0&id=b52f0886&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52f0886",
  null
  
)

export default component.exports